import { RootState } from '@store';

export const selectVehicleConfiguration = (state: RootState) => {
  return state.vehicleConfiguration?.vehicleConfiguration;
};

export const selectVehicleModel = (state: RootState) => {
  return selectVehicleConfiguration(state)?.model;
};

export const selectVehicleType = (state: RootState) => {
  return selectVehicleModel(state)?.vehicleType;
};

export const selectCurrentVehicleConfig = (state: RootState) => {
  return state.vehicleConfiguration?.currentVehicleConfig;
};

export const selectVehicleList = (state: RootState) => {
  return state.vehicleConfiguration?.vehicleList;
};
